import { render, staticRenderFns } from "./bot_mobile.vue?vue&type=template&id=68279258&scoped=true&"
import script from "./bot_mobile.vue?vue&type=script&lang=js&"
export * from "./bot_mobile.vue?vue&type=script&lang=js&"
import style0 from "./bot_mobile.vue?vue&type=style&index=0&id=68279258&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68279258",
  null
  
)

export default component.exports